import { REVIEWSCHEDULER } from "../../../utils/Constants";

export const createAMDashboardFilter = (set, get) => ({
    AMDashboardFilter: {
        agency_id: '',
        all_agency: true,
        datemodified: {
            start_date: undefined,
            end_date: undefined
        },
        page: 1,
        field: 'updated_on',
        direction: 'desc',
        userType: REVIEWSCHEDULER,  //need to check with BE,
        // type_of_call : undefined,
        isDateRangeClicked: "",
        isAllBfiles: true
    },

    setAMDashboardFilter: (newFilter) =>
        set((state) => ({
            AMDashboardFilter: {
                ...state.AMDashboardFilter,
                ...newFilter,
                datemodified: {
                    ...state.AMDashboardFilter.datemodified,
                    ...newFilter.datemodified,
                }
            },
        })),

    resetAMDashboardFilter: () =>
        set(() => ({
            AMDashboardFilter: {
                agency_id: '',
                all_agency: true,
                datemodified: {
                    start_date: undefined,
                    end_date: undefined
                },
                page: 1,
                field: 'updated_on',
                direction: 'desc',
                userType: REVIEWSCHEDULER,  //need to check with BE,
                // type_of_call : undefined
                isDateRangeClicked: "",
                isAllBfiles: true
            },
        })),
});



// WEBPACK FOOTER //
// ./src/store/slices/AMSlice/AMDashboardSlice.js